import React from 'react';
 import { getUserData } from '../auth';
import TransactionsTableNetProfit from './TransactionsTableNetProfit';

const TransactionsTableTrue = () => {

  const userData = getUserData();
  const userId = userData?.uid || "";
  const isActive = true; // Replace with dynamic filter

  return (
    <div>
      <h4>My Transactions </h4>
      <TransactionsTableNetProfit userId={userId} isActive={isActive} />
    </div>
  );
};

export default TransactionsTableTrue;